export const REPORT_DOCUMENT_TYPES = {
  REPORT_CARD: 'report-card',
  RESULT: 'result',
  TC: 'transfer-certificate',
  CERTIFICATE: 'certificate',
  ID_CARD: 'id-card',
};

export const REPORT_PAGE_META = {
  [REPORT_DOCUMENT_TYPES.REPORT_CARD]: {
    title: 'Report Card',
    description: 'Generate detailed student report cards with marks, grades, attendance, and remarks.',
    showExamMode: true,
    showCertificateFields: false,
    showCardFormat: false,
    bulkLabel: 'Bulk Report Cards',
    tcBulkOnly: false,
  },
  [REPORT_DOCUMENT_TYPES.RESULT]: {
    title: 'Result',
    description: 'Generate exam result sheets with preview and PDF export.',
    showExamMode: true,
    showCertificateFields: false,
    showCardFormat: false,
    bulkLabel: 'Bulk Results',
    tcBulkOnly: false,
  },
  [REPORT_DOCUMENT_TYPES.TC]: {
    title: 'Transfer Certificate',
    description: 'Generate transfer certificates with admission details, leaving date, and reason.',
    showExamMode: false,
    showCertificateFields: false,
    showCardFormat: false,
    bulkLabel: 'Bulk TC (Class 12 only)',
    tcBulkOnly: true,
  },
  [REPORT_DOCUMENT_TYPES.CERTIFICATE]: {
    title: 'Certificate',
    description: 'Generate certificates using templates configured in Settings.',
    showExamMode: false,
    showCertificateFields: true,
    showCardFormat: false,
    bulkLabel: 'Bulk Certificates',
    tcBulkOnly: false,
  },
  [REPORT_DOCUMENT_TYPES.ID_CARD]: {
    title: 'ID Card',
    description: 'Generate student ID cards with photo, class details, and QR code.',
    showExamMode: false,
    showCertificateFields: false,
    showCardFormat: true,
    bulkLabel: 'Bulk ID Cards',
    tcBulkOnly: false,
    allowAllClasses: true,
  },
};

export function isClassTwelveStudent(student) {
  if (!student) return false;
  if (Number(student.class_numeric) === 12) return true;
  const name = String(student.class_name || '');
  return /\b(12|XII|12th)\b/i.test(name);
}

export function buildReportPreviewUrl(documentType, params) {
  const qs = new URLSearchParams(params).toString();
  return `/reports/${documentType}/preview?${qs}`;
}

export function buildReportPdfUrl(documentType, params) {
  const qs = new URLSearchParams(params).toString();
  return `/reports/${documentType}/pdf?${qs}`;
}
